import React from 'react';

import { Button, Modal, notification, Tag, Tooltip } from 'antd';
import { Booking } from '../../model/Booking';
import Request from '../../model/Request';

import parse from 'url-parse';
//import {hasRole} from '../../utils/token/TokenUtils.ts.old';
// import { rootAPI } from '../../constants/globals';
import { Actions, Subjects } from '../../configuration/permission/ability';
import { isNullOrUndefined, setUrlToHTTPs } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';
import { useKeycloak } from '@nic-react/auth';
import { useLocation, useNavigate } from 'react-router';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useAppendAuthorizationHeader } from '../../utils/connector/api-connector';
import dayjs from 'dayjs';
import { Can } from '../../context/Authorization';
import { queryClient } from '../../index';

interface BookingViewerInterface {
    index: number
    request: Request
    booking: Booking
    onSelectedBooking?: () => void
}

type BookingViewerProps = BookingViewerInterface

const icon: Record<string, string> = {
    'succeeded': 'fa-thumbs-up',
    'failed': 'fa-thumbs-down',
    'pending': 'fa-hourglass',
    'ban': 'fa-ban',
};

const color: Record<string, string> = {
    'succeeded': 'green',
    'failed': 'red',
    'pending': 'orange',
    'ban': 'red',
};


const BookingViewer:React.FC<BookingViewerProps> = (props) => {
    const {booking, request} = props;


    const {t} = useTranslation()
    const {keycloak} = useKeycloak()
    const navigate = useNavigate()
    const location = useLocation()

    const [deleteBooking, setDeleteBooking] = React.useState(false)
    const [spinning] = React.useState(false)

//    const bookingFormat: string = 'DD-MM-YYYY HH:mm'
    const header = useAppendAuthorizationHeader()
    //console.log('BookingViewer Result: ', booking.hasResults, booking, booking.links.result.href)

    let resultValue = undefined

    let component = null;

    const deleteDate = async (bookUrl: string) => {
        //const [rootApi] = AppConf.getRootUrl(keycloak.realm)

        const response = await fetch(`${bookUrl}`,
            {
                method: 'DELETE',
                ...header
            })

        if (!response.ok) {
            throw new Error()
        }
    }


    const {mutateAsync} = useMutation(deleteDate)




    const resultData = useQuery({
        enabled: booking.hasResults,
        queryKey: ['booking', booking.id, 'result'],
        queryFn: async () => {
            const data =
                await fetch(setUrlToHTTPs(booking.links.result.href), {...header})
            return data.json()
        }
    })

    if (resultData.isFetched) {
        resultValue = resultData.data
        //console.log('ResultData: ', resultValue)
    }
/*
    const renderBooking = () => {
        const {booking} = props;

        return (
            <div>
                <span>{booking.created.format(bookingFormat)}</span>
                <span>{booking.serverName}</span>
                <span>{booking.testDate.format(bookingFormat)}</span>
            </div>
        );
    }
*/
    const buildBookInfo = (creationDate: dayjs.Dayjs, pushUrl: string,
                           formattedString: string,  selected: boolean,
                           onClick: () => void | undefined,
                           resultValue: any | undefined) => {
        // const {history} = this.props;

        let cancellable = isNullOrUndefined(resultValue) || creationDate.isSame(dayjs() || creationDate.isAfter(dayjs()));

        //console.log('BuildBookingInfo: ', cancellable, ' resultValue: ', resultValue, creationDate, creationDate.toDate(), convertDate(locale, creationDate.toDate(), DATE_CONF), selected)


        let iconVal = 'pending';
        if (!cancellable) {
            iconVal = 'ban';
        }
        if (!cancellable) {
            iconVal = resultValue.status;
        }

        let isRegistryOperator: boolean = keycloak.realm === 'registry'

        // let iconVal = (isNullOrUndefined(resultValue) ? 'pending' : resultValue.status);
        let colorVal = iconVal;
        let cursor = 'pointer'; // (isNullOrUndefined(resultValue) ? 'not-allowed' : 'pointer');
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    cursor: cursor,
                    paddingBottom: '10px', paddingTop: '10px'
                }}
                onClick={() => {

                    //console.log('OnClick? ', onClick)
                    if (!isNullOrUndefined(onClick  )) {

                        props.onSelectedBooking && props.onSelectedBooking();

                        onClick();
                    }
                }}
            >
                <span
                    style={{
                        color: color[colorVal],
                        paddingRight: '5px'
                    }}
                >
                    <i className={`fal ${icon[iconVal]}`}/>
                </span>
                <Tag
                    style={{
                        cursor: cursor,
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center'
                    }}
                >
                    <i
                        className={'fal fa-calendar'}
                    />

                    <span
                        style={{
                            color: (selected ? '#418eff' : 'black'),
                            fontWeight: (selected ? 700 : 400),
                            paddingRight: '10px'
                        }}
                    >
                        {new Intl.DateTimeFormat("it-IT", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            hour12: false,
                            timeZoneName: "short"}).format(creationDate.toDate())}
                    </span>
                </Tag>
                {cancellable && !isRegistryOperator &&
                    <Can I={Actions.DELETE} an={Subjects.BOOKING}>
                        <Tooltip title={t('tooltip.booking.delete')} placement={'top'}>
                            <Button
                                type="primary"
                                shape="circle"
                                size={'small'}
                                onClick={() => {
                                    setDeleteBooking( true);
                                    // console.log('Delete.. open modal');
                                }}
                            >
                                <i className={'fal fa-trash'}/>
                            </Button>
                        </Tooltip>
                    </Can>
                }
            </div>
        );
    }

    const renderModal = () => {
        const {booking} = props;
//        const [rootAPI] = AppConf.getRootUrl(keycloak.realm ? keycloak.realm : '');
        // console.log('UseHateoas: ', useHateoas);
        return (
            <Modal
                title={t('modal.booking.delete.title')}
                open={deleteBooking || spinning}
                okText={t('modal.booking.delete.ok')}
                cancelText={t('modal.booking.delete.cancel')}
                onCancel={() => {setDeleteBooking( false); }}
                okButtonProps={{loading:spinning}}
                onOk={() => {
                    // const {links} = booking;
                    notification.info({
                        message: t('booking.notification.title'),
                        description: t('booking.notification.delete.description'),
                    });

                   mutateAsync(booking.links.self.href).then(() => {
                       notification.success({
                           message: t('booking.notification.title'),
                           description: t('booking.notification.delete.success'),
                       });
                       component = <></>
                   }).catch((error) => {
                       notification.error({
                           message: t('booking.notification.title'),
                           description: t('booking.notification.delete.error'),
                       });
                   }).finally(() => {
                       Promise.all([
                           queryClient.invalidateQueries({queryKey: ['requests', 'request', `${request.id}`]}),
                               queryClient.invalidateQueries({queryKey: ['requests', 'request', `${request.id}`, 'booking']})])
                           .then(() => {

                           navigate(`/requests/${request.id}`)
                       })
                   })
                   // props.deleteBooking(`${rootAPI}/bookings/${booking.id}`);
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            fontSize: '3rem',
                            color: 'orange',
                            marginRight: '20px',
                        }}
                    >
                        <img alt={'question'} className={'fal fa-question-circle'}/>
                    </div>
                    <div>{t('modal.booking.delete.question')}</div>
                </div>
            </Modal>
        );
    }
    /*
        const checkDeleteAction = (action: any,
                                   prevAction: any,
                                   onSuccess: (value: any) => void) => {

            if (action) {
                if (changedPostStatus(action, prevAction)) {
                    if (action.pending) {
                        setSpinning(true);
                    } else {
                        if (action.rejected) {
                            setSpinning(false)
                            setDeleteBooking( false );
                            notification.error({
                                message: t('booking.notification.title'),
                                description: errorMessage(action)
                            });
                        } else {
                            if (action.fulfilled) {
                                notification.success({
                                    message:
                                        t('booking.notification.title'),
                                    description:
                                        t('booking.notification.delete.success.description')
                                });
                                setSpinning(false);
                                // console.log('CHECKPUTACTION: ', action.value);
                                onSuccess(true);
                            }
                        }
                    }
                }
            }
        }

        const rigthPromise = (index: number, booking: Booking, resultPromise: any): boolean => {
            let res: boolean = booking.hasResults;

            if (booking.hasResults && resultPromise && resultPromise.fulfilled) {
                return (resultPromise.value._links.booking.href === booking.links.self.href);
            }

            return res;
        }
    */

    const {index} = props;
    const {search, pathname} = location;

    let url = parse(pathname + search, true);
    let query = url.query;
    let selected = false;
    let border = 'transparent';
    let formattedString = t('formatter.dateAndHour');
    let modal = renderModal();


    //console.log('BookingView: ', booking)


    if (isNullOrUndefined(component)) {

        if (!isNullOrUndefined(query.booking)) {
            selected = (parseInt(query.booking??'0', 10) === index);
        }
        let pushUrl =
            pathname +
            '?'+

            'booking=' + index
            //+'&request=' + url.query.request +
        ;

        border = (selected ? '2px solid #1890ff' : 'transparent');


        if (booking.hasResults) {
            if (resultValue !== undefined) {
                component =
                    buildBookInfo(
                        dayjs(booking.testDate), pushUrl, formattedString,
                        selected,
                        () => {
                            //console.log('OnCLick ext ss: ', pushUrl)
                            navigate(`${pushUrl}`);

                        }, resultValue
                    );
            }
        } else {
            let pushUrl =
                pathname
            selected = true

            if (query.booking !== undefined) {
                selected = (parseInt(query.booking, 10) === index);
            }

            pushUrl += '?booking=' + index;

            border = (selected ? '2px solid #1890ff' : 'transparent');

            component =
                buildBookInfo(
                    dayjs(booking.testDate), pushUrl, formattedString,
                    selected,
                    () => {
                       // console.log('OnClick external: ', pushUrl)
                        navigate(`${pushUrl}`);
                        }, null
                );
        }
    }

    return (
        <div>
        <div style={{borderBottom: border, marginRight: '20px'}}>
            {modal}
            {component}
        </div>
        </div>
    );

}

export default BookingViewer

/*
export default connect((props: BookingViewerProps): any => {
    if (props.token && props.token.authenticated) {
        const {booking} = props;
        const headers = appendAuthorizationHeader(props).headers;
        let result = booking.links.result;
        const [rootAPI, useHateoas] = AppConf.getRootUrl(props.token.realm ? props.token.realm : '');
        // console.log('UseHateoas: ', useHateoas);
        if (result) {
            let url = '';
            if (useHateoas) {
                url = result && result.href !== null ? result.href : '';
            } else {
                url = `${rootAPI}${parse(result.href, true).pathname}`;
            }

            return ({
                result: {url: setUrlToHTTPs(url), headers: headers},
                deleteBooking: (bookingUrl: string) => {

                    return ({
                        deleteBookingResponse: {
                            url:  bookingUrl,
                            headers: headers,
                            method: 'DELETE'
                        }
                    });
                }
            });
        } else {
            return ({
                deleteBooking: (bookingUrl: string) => {

                    return ({
                        deleteBookingResponse: {
                            url:  bookingUrl,
                            headers: headers,
                            method: 'DELETE'
                        }
                    });
                }
            });
        }
    }
})(
    withRouter(
        injectIntl(BookingViewer)
    )
);
*/